import {Component, OnInit, ViewChild, signal} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AddMasterProductComponent } from './add-master-product/add-master-product.component';
import { DeleteMasterProductComponent } from './delete-master-product/delete-master-product.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PaginationComponent } from '../../common/pagination/pagination.component';
import { MasterdataService } from '../../services/masterdata.service';

@Component({ 
  selector: 'app-master-countries',
  standalone: true,
  imports: [CommonModule,FormsModule,PaginationComponent],
  templateUrl: './master-countries.component.html',
  styleUrls: ['./master-countries.component.scss', '../../../app.component.scss']
})
export class MasterCountriesComponent implements OnInit{
  @ViewChild(PaginationComponent) paginationView: PaginationComponent;
  
  totalCountryCount: number = 0;
  public alerts: any = []
  public delete: any = []
  public fileType = "";
  public isFile = false;
  public uploadedFile: any;
  public statusType: string = "";
  public statusMessage: string = ""; 
  public country: any = [] 
  // public countries: any = []
  public isDragOver = signal(false);
  public regions: any = [];

  public searchInput: string = "";
  public encodedSearchInput: string = "";

  public isSearch = false;
  public isFilter = false;
  public isFilterResult = true;
  public totalPages: number = 0;
  public currentPage: number = 1;
  public paginationData: any;
  public search : any = [];

  public selectedStatus = [];

  constructor(public dialog: MatDialog, public masterdataService: MasterdataService) { }

  ngOnInit(): void {
    this.getMasterRegions()
    this.getMasterCountry(this.search,this.currentPage)
  }

  dropFile(e) {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file) {
      this.fileValidation(file)
    }
    
    this.isDragOver.set(false);
  }

  dragOverFile(e) {
    e.preventDefault();
    this.isDragOver.set(true);
  }

  dragLeaveFile(e) {
    e.preventDefault();
    this.isDragOver.set(false);
  }

  browseFile(e){
    e.preventDefault();
    let fileInput = document.getElementById("file-input");
    fileInput.click();
  }
  
  dragEndFile(e) {
    e.preventDefault();
    this.isDragOver.set(false);
  }

  onFileChange(event){
    event.preventDefault();
    const file = event.target.files[0];
    if (file) {
      this.fileValidation(file);
    }
  }

  fileValidation(file){
    const validFileTypes = ['csv', 'xlsx', 'xls'];
    let ext = file.name.substring(file.name.lastIndexOf('.') + 1);
    if (validFileTypes.includes(ext)) {
      this.isFile = true;
      this.uploadedFile = file;
    }else{
      this.statusType = 'error';
      this.statusMessage = `File format is invalid. Only Excel and CSV formats are allowed.`;
      this.showWarningToast();
    }
  }

  resetFile(){
    this.isFile = false;
  }

  showWarningToast(){
    const toastContainer = document.getElementById('warning-toast');

    setTimeout(function() {
      toastContainer.classList.add('show');
    }, 100);

    setTimeout(function() {
      toastContainer.classList.remove('show');
    }, 5000);
  }
 
  openDialog(country): void {
    this.getMasterRegions()
    const dialogRef = this.dialog.open(AddMasterProductComponent, {
      data:{
        type: "add",
        regions: this.regions
      } 
    });
    dialogRef.afterClosed().subscribe(()=>{
      this.getMasterRegions()
      this.getMasterCountry(this.search,this.currentPage)
    });
  }  

  
  openDeleteDialog(item: any): void {
    console.log("deleteid", item)
    const dialogRef = this.dialog.open(DeleteMasterProductComponent, {
    }).afterClosed().subscribe(result=>{
      if(result == "confirm"){
        this.masterdataService.deletelocations(item.id, "country").subscribe((res:any)=>{
          if(res && res.success){
            this.getMasterRegions();
            this.getMasterCountry(this.search,this.currentPage);
          }
        }) 
      }
    });

  }

  openEditDialog(country:any): void {

    const dialogRef = this.dialog.open(AddMasterProductComponent, {
      disableClose: true,
      data: {
        type: "edit",
        item: country,
        regions: this.regions
      }
    }).afterClosed().subscribe(()=>{
      this.getMasterRegions()
      this.getMasterCountry(this.search,this.currentPage)
    });
  }
  


  getMasterRegions(){
    this.masterdataService.getMasterRegions(this.search,this.currentPage).subscribe((res)=>{
      if (res.data && res.data.data) {
        this.regions = res.data.data.map(item => {return {id:item.id, value:item.name}});
      }
    });
  }
  
  getMasterCountry(search: string = "", currentPage: number){
    this.masterdataService.getMasterCountry(search, currentPage).subscribe((res)=>{
      if (res.data) {
        this.country = res.data.data;
        this.paginationData = res.data.data;
        this.totalCountryCount =  res.data.total;
        this.paginationData.totalPage = Math.ceil(res.data.total / 15);
        console.log(this.paginationData, " paginationData");
      }
    });
  }

  onSearchSubmit(){
    if (this.searchInput !== "") {
      this.isSearch = true;
      if (this.isFilter) { 
        this.isFilter = false;
        this.isFilterResult = true;
      }
      this.encodedSearchInput = encodeURIComponent(this.searchInput);
      this.getMasterCountry(this.encodedSearchInput, this.currentPage);
    }
  }

  getQueryPage(event:any){
    console.log(event);
    this.currentPage = event;
    this.getMasterCountry(this.search,this.currentPage)
  }

  reset(event: Event){
    event.preventDefault();
    if (this.isSearch || this.isFilter) {
      this.encodedSearchInput = "";
      this.selectedStatus = [];
      this.isSearch = false;
      this.isFilter = false;
      this.isFilterResult = true;
      this.getMasterCountry(this.encodedSearchInput, this.currentPage);
    }
  }

}
